<template>
    <div class="height-emulator"></div>
</template>

<script>
export default {
  name: 'HeightEmulatorComponent'
}
</script>
